import React from 'react';

export const ButtonIcon = ({ className = '', size = 40 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="75 90 350 300" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ 
      marginLeft: '8px', 
      verticalAlign: 'middle',
      display: 'inline-flex',
      transform: 'translateY(-2px)'
    }}
  >
    {/* Left shape */}
    <path 
      d="M104 128 
         Q 104 112 120 112 
         H 224 
         Q 232 112 238 120 
         L 310 224 
         Q 312 227 310 230 
         L 238 336 
         Q 232 344 224 344 
         H 120 
         Q 104 344 104 328 
         Z" 
      fill="currentColor"
    />
    {/* Right chevron */}
    <path 
      d="M246 112 
         Q 252 112 256 118 
         L 326 224 
         Q 328 227 326 230 
         L 256 336 
         Q 252 344 246 344 
         H 346 
         Q 352 344 356 338 
         L 426 230 
         Q 428 227 426 224 
         L 356 118 
         Q 352 112 346 112 
         H 246 Z" 
      fill="currentColor"
    />
  </svg>
); 